// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "app" + "." + "eba1b13a13f43ab6e9e9" + ".css";
};